export default {
  data() {
    return {
      idInputDisable: false,
      nameInputDisable: false,
      keywordId: '',
      keywordType: '',
      keywordName: '',
      tableData: [],

      // 控制对话显示
      dialogTableVisible: false,
      formLabelWidth: "120px",
      dialogTableVisible2: false,
      dialogTableVisiblexiugai: false,

      currentPage: 1,
      totalPage: 0,
      offset: '0',
      resourceLength: 30,

      action: this.baseUrl + 'file/upload_music?token=' + this.$store.state.authority_management,
      fileList: [],
      formLabelWidth: "120px",
      fileName: '',
      docName: '',
      //更新音频传给后端的对象
      updateAudio: {
        name: '',
        data: '',
        id: '',
      }
      // pagesizes:[],
    }
  },
  methods: {
		// 上传文件
		httpreq(q){
			this.$upload(this.action,q)
		},
    onSearch() {
      let data = { token: this.$store.state.authority_management, name: this.keywordName, offset: 0, length: 999, type: 3 };
      // 这里调用搜索资源接口
      this.$post('resources/shop_search', data).then(res => {
        // // console.log(res)
        this.tableData = res.data.result.data
        this.totalPage = res.data.result.total
		this.currentPage = 1
        // // console.log(tableData)
        // alert("资源序号:" + tableData[0].id + "，资源名称:" + tableData[0].name + "，资源类型:" + tableData[0].type + "，试题")
      })
    },
    oncli(dataa) {
      // alert(dataa);
    },
    onSubmit() {
      // 这里调用提交修改的接口
      // this.$post(url, data).then(res => {
      //   // console.log(res);
      // });
      // this.dialogTableVisible = false;
    },
    onReset(formName) {
      // 这里是清空修改中的内容 不用管
      this.dialogTableVisible = false;
      this.$refs[formName].resetFields();
    },
    confirmDelete(id) {
      // alert(id);
      //调用删除接口
      let data = { token: this.$store.state.authority_management, id: id };
      this.$post('resources/delete', data).then(res => {
        // // console.log(res.data.status);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getData();
      });
    },
    //5/24号修改
    hendelDeleteshanchu(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmDelete(id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    handleModify(id) {
    },
    onModify: function () {
      this.dialogTableVisible2 = true
    },
    onBack: function () { },
    handleSizeChange(val) {
      // // console.log(`每页 ${val} 条`);
      this.resourceLength = val;
      this.getData();
    },
    handleCurrentChange(val) {
      // // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.offset = (val - 1) * this.resourceLength;
      this.getData();
    },
    hendelDelete(id) {
      // alert(id);
      //调用删除接口
      let data = { token: this.$store.state.authority_management, id: id };
      this.$post('resources/delete', data).then(res => {
        // // console.log(res.data.status);
      });
    },
    handleRemove(file, fileList) {
      // // console.log(file, fileList);
    },
    handlePreview(file) {
      // // console.log(file);
    },
    handleSuccess(response, file, fileList) {
      // 上传成发生的事件
      // // console.log('文件上传成功');
      // // console.log(response.result);
      // // console.log(file);
      // // console.log(fileList);
      this.fileName = response.result
      // if(response.status == 'success'){
      //   this.$post('resources/shop_create',{token:this.$store.state.id,name:file.name,data:this.fileName, type:'3'}).then(res=>{
      //     // console.log(res)
      //   })
      // }
      // dialogTableVisible = false;
    },
    //确定提交资源插入数据库
    confirmSubmit() {
      if (this.fileName == '') {
        this.$message({
          showClose: true,
          message: '请确保你已经上传文件且上传成功',
          type: 'error'
        });
        return false;
      } else if (this.docName == '') {
        this.$message({
          showClose: true,
          message: '文件名字不能为空！',
          type: 'error'
        });
        return false;
      }
      this.$post('resources/shop_create', { token: this.$store.state.authority_management, name: this.docName, data: this.fileName, type: '3' }).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            showClose: true,
            message: '新增音频资源成功！',
            type: 'success'
          });
          this.dialogTableVisible = false;
          this.getData();
          this.fileList=[];
          this.docName='';
        } else {
          this.$message({
            showClose: true,
            message: '新增音频资源失败！',
            type: 'error'
          });
        }

      })
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    getData() {
      let data = { token: this.$store.state.authority_management, type: 3, name: this.keywordName, offset: this.offset, length: this.resourceLength };
      this.$post('resources/shop_search', data).then(res => {
        // // console.log(res.data)
        this.tableData = res.data.result.data;
        this.totalPage = res.data.result.total;
        // this.tableData.map((item) => {
        //   item.type = "音频类型"
        // })
      })
    },
    //修改资源
    updateAudioSourse(item) {
      // this.obj=item;
      // // console.log(item);
      this.updateAudio.name = item.name;
      this.updateAudio.id = item.id;
      this.updateAudio.data = item.data;
      this.dialogTableVisiblexiugai = true
    },
    updateAudioSubmit() {
      // updateAudio
      let data = {
        id:this.updateAudio.id,
        token: this.$store.state.authority_management,
        name: this.updateAudio.name,
        data: this.updateAudio.data,
        type: '3'
      }
      if (this.updateAudio.name == '') {
        this.$message({
          showClose: true,
          message: '文件名字不能为空！',
          type: 'error'
        });
        return false;
      }
      this.$post('resources/shop_edit', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            showClose: true,
            message: '修改音频资源名字成功',
            type: 'success'
          });
          this.dialogTableVisiblexiugai = false;
          this.updateAudio= {
            name: '',
            data: '',
            id: '',
          }
          this.getData();
        } else {
          this.$message({
            showClose: true,
            message: '修改音频资源名字失败',
            type: 'error'
          });
        }

      })
    },
    beforeUpload(file){
      // // console.log(file);
      const isAudio = file.name.replace(/.+\./, "");
      if(['mp3'].indexOf(isAudio) == '-1'){
        // // console.log('进入判断')
        this.$message({
          showClose: true,
          message:'上传文件类型错误！',
          type:'warning'
        })
        return false
      }
      // // console.log(isAudio)
    },
  },
  created() {
    // 获取数据
    this.getData();
  },

}